import React, { createContext, useContext, useEffect, useState } from "react";
import api, { setAuthToken } from "./api";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
  });

  const navigate = useNavigate();

  // Make sure axios has the token set on load
  useEffect(() => {
    const token = user?.token;
    setAuthToken(token);
  }, [user]);

  const login = async (username, password) => {
    const res = await api.post("/auth/login", { username, password });
    const userData = res.data;
    // store entire user object
    localStorage.setItem("user", JSON.stringify(userData));
    localStorage.setItem("token", userData.token);
    setAuthToken(userData.token);
    setUser(userData);
    return userData;
  };

  const logout = async () => {
    try {
      // call backend logout first (best-effort)
      await api.post("/auth/logout");
    } catch (err) {
    } finally {
      // clear local data and axios header, hide header (user -> null)
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      setAuthToken(null);
      setUser(null);
      navigate("/login");
    }
  };

  const refreshUser = (freshUser) => {
    // utility: update stored user object (e.g., refresh balance)
    localStorage.setItem("user", JSON.stringify(freshUser));
    setUser(freshUser);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
